import { DetailSectionNav } from '../shared/DetailSectionNav';
import { jobSections } from './jobSections';

export function JobSectionNav({ active, onChange, photos, documents }: {
  active: number; onChange: (value: number) => void; photos: number; documents: number;
}) {
  return <DetailSectionNav entity="Job" active={active} onChange={onChange}
    sections={jobSections.map((section, index) => ({
      ...section, value: index,
      title: `${section.title}${section.key === 'photos' ? ` (${photos})` : section.key === 'documents' ? ` (${documents})` : ''}`,
    }))} />;
}
